import React, { Component } from 'react';
import { Select, Button } from 'antd';

const { Option } = Select;

class ChoiceOfAssets extends Component {
	state = {
		currency: 'btc'
	};

	handleClick = async () => {
		const { next } = this.props;
		const { currency } = this.state;
		
		next(currency);
		
	};

	handleChange = (currency) => {
		this.setState({ currency });
	};

	renderOptions = () => {
		const { coin } = this.props;
		const List = coin.map((item) => (
			<Option value={item.value} key={item.value}>
				{item.key}
			</Option>
		));
		return List;
	};

	render() {
		const { currency } = this.state;
		return (
			<div>
				<p style={{ paddingTop: '12px' }}>
					Simply charge your account below with a crypto and automatically
					get XHT.
				</p>
				<div>
					<p>
						<b>Charge account with:</b>
					</p>
					<Select
						value={currency}
						onChange={this.handleChange}
						style={{ width: '100%' }}
					>
						{this.renderOptions()}
					</Select>
				</div>
				<div className="btn-area">
					<Button block type="primary" onClick={this.handleClick}>
						Next
					</Button>
				</div>
			</div>
		);
	}
}

export default ChoiceOfAssets;
